module.exports = __webpack_public_path__ + "img/drm-on-gradient.13f9667b.svg";